import { InspectGCF } from './pages/inspect.js'
import { grantContractFraudAllegation } from '../../../choices'
import {
  allegationPage,
  commonPageSequence,
  employeePage,
  grantContractPage,
  hhsProgramsPage,
  reviewPage
} from '../../../pages'

export const formSchema = saveComplaint => {
  // Define the GCF specific pages
  const pageAfterGrant = 'hhs_program_page'
  const initialPages = [
    allegationPage({ choices: grantContractFraudAllegation() }),
    grantContractPage({ pageAfterGrant }),
    grantContractPage({ index: 1, pageAfterGrant }),
    grantContractPage({ index: 2, pageAfterGrant }),
    grantContractPage({ index: 3, pageAfterGrant }),
    grantContractPage({ index: 4, pageAfterGrant }),
    grantContractPage({ index: 5, pageAfterGrant }),
    grantContractPage({ index: 6, pageAfterGrant }),
    grantContractPage({ index: 7, pageAfterGrant }),
    grantContractPage({ index: 8, pageAfterGrant }),
    grantContractPage({ index: 9, pageAfterGrant }),
    hhsProgramsPage()
  ]

  // Define the review page
  const finalPages = [employeePage(), reviewPage(InspectGCF)]

  return {
    title: 'Grant or Contract Fraud Complaint Form',
    onSubmit: formValues => saveComplaint(formValues),
    pages: initialPages.concat(
      commonPageSequence({ includeVictim: false }),
      finalPages
    )
  }
}
